import { render, staticRenderFns } from "./InvestBlock.vue?vue&type=template&id=36964994&scoped=true&"
import script from "./InvestBlock.vue?vue&type=script&lang=ts&"
export * from "./InvestBlock.vue?vue&type=script&lang=ts&"
import style0 from "./InvestBlock.vue?vue&type=style&index=0&id=36964994&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36964994",
  null
  
)

export default component.exports